import { NgModule } from '@angular/core';
import { LocalService } from '../local.services';
import { SharedModule } from '@core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AppStep3Component } from './step3.component';
import { AppTooltipModule } from '@core/components/tooltip/tooltip.module';
import { AppProgresStepsModule } from '../probress-steps/progress-steps.module';
const routes = [
    {
        path: ':id',
        component: AppStep3Component,
        resolve: {
            local: LocalService
        }
    }

];

@NgModule({
    declarations: [
        AppStep3Component,
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AppTooltipModule,
        AppProgresStepsModule,
    ],
    providers: [
    ]
})

export class Step3Module {

}
